import { render } from "./DSSTable.vue?vue&type=template&id=f27358be&scoped=true"
import script from "./DSSTable.vue?vue&type=script&lang=js"
export * from "./DSSTable.vue?vue&type=script&lang=js"

import "./DSSTable.vue?vue&type=style&index=0&id=f27358be&lang=scss&scoped=true"

import exportComponent from "/Users/berkuralcan/Documents/dev/webdev/dansuk-engineering-dashboard-v3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f27358be"]])

export default __exports__